import React, { Children, useEffect, useRef, useState } from "react";
import FadeIn from "react-fade-in";
import {
  CrossIcon,
  EditPencilIcon,
  EditPencilIcon2,
  TableSortIconDownArrow,
} from "../../utils/icons/defaultIcons";
import TableTopBar from "../modal/tableTopBar";
import Table from "../../atom/table";
import Loader from "../loader";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PaginationButtons from "../../atom/pagination";
import { Backdrop, CircularProgress } from "@mui/material";
import Notification from "../../atom/Notification";
import Lottiefy from "../../atom/lottie/lottie";
import * as loaderLottie from "../../utils/lottie/loaderLottie.json";
import { setBreadcrumbs } from "../../toolkit/reducers/breadCrumbsSlice";
import ComponentMap from "../../atom/componentmap";
import ThemedButton from "../../atom/ThemedButton/themedButton";
import {
  add_New_DCID_Plan,
  get_NewPlan_Data,
  update_Individual_Dcid_Plan,
  view_Individual_Plan,
} from "../../services/api";

function EditDcidPlan() {
  const resRef = useRef<any[]>([]);
  const unselectedRef = useRef<any[]>([]);
  const [manageState, setManageState] = useState<string>("");
  const [checkedAll, setCheckedAll] = useState<boolean>(false);
  // const [tableData, setTableData] = useState<any>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageCount, setPageCount] = useState<number>(0);
  const [perPage, setPerPage] = useState<number | string>(10000);
  const [resultNotFound, setResultNotFound] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>({ name: "", dids_per_npa: "" });
  const [isDirty, setIsDirty] = useState(false);
  const [planData, setPlanData] = useState({
    name: "",
    dids_per_npa: NaN,
  });

  const [loader, setLoader] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const activeBreadCrumbs = useSelector(
    (state: any) => state.BreadCrumbsList.brudCrubName
  );
  var res = [...activeBreadCrumbs];
  const { id } = useParams();
  const [tableTitles, setTableTitles] = useState<any>([
    {
      key: "state",
      title: "State",
      icon: <TableSortIconDownArrow />,
      sort: { direction: "asc", active: false },
    },
    {
      key: "rate_center_display",
      title: "Rate Center",
      icon: <TableSortIconDownArrow />,
      sort: { direction: "asc", active: false },
    },
    {
      key: "npa",
      title: "NPA",
      icon: <TableSortIconDownArrow />,
      sort: { direction: "asc", active: false },
    },
    {
      key: "",
      type: "checkbox",
      // column_select_hidden: false,
      classname: "float-right ",
      selectAll: true,
    },
  ]);

  const [tableData, setTableData] = useState<any>([]);

  const [searchtext, setSearchText] = useState<any>("");
  const [sort, setSort] = useState<any>({
    key: "is_selected",
    order: "ASC",
  });
  const [handleKeyPress, setHandleKeyPress] = useState<boolean>(true);
  console.log("edit dcicd plan");
  const path = useLocation();

  // const onHandleFetch: any = (options: {
  //   limit?: number;
  //   searchtext?: string;
  //   pageNumber?: number;
  //   sort_column?: string;
  //   sort_direction?: string;
  // }) => {
  //   let newsortkey = "";
  //   if (sort.key === "rate_center_display") {
  //     newsortkey = "rate_center";
  //   } else {
  //     newsortkey = sort.key;
  //   }
  //   setLoader(true);
  //   view_Individual_Plan(
  //     {
  //       limit: options?.limit || perPage,
  //       pageId: options?.pageNumber || pageNumber,
  //       sort_column:
  //         options?.sort_column === "rate_center_display"
  //           ? "rate_center"
  //           : options?.sort_column || newsortkey,
  //       sort_direction: options?.sort_direction || sort.order,
  //       searchtext:
  //         options?.searchtext === undefined
  //           ? searchtext
  //           : options?.searchtext === ""
  //           ? ""
  //           : options?.searchtext,
  //     },
  //     id
  //   ).then((result: any) => {
  //     const plans = result?.data?.items;
  //     if (!result.success || plans?.length === 0) {
  //       setLoader(false);
  //       setResultNotFound(true);
  //     } else {
  //       setResultNotFound(false);
  //       setPlanData(result?.data);
  //     }
  //     // setTableData(plans);
  //     const updatedPlans = plans.map((plan: any) => {
  //       if (plan.is_selected) {
  //         resRef.current.push(plan);

  //         return { ...plan, checked: true };
  //       }
  //       const isSelected = resRef.current.some(
  //         (item: any) => item.uuid === plan.uuid
  //       );
  //       return isSelected ? { ...plan, checked: true } : plan;
  //     });
  //     const checkAllPlans = plans.map((plan: any) => {
  //       return { ...plan, checked: true };
  //     });

  //     if (!checkedAll) {
  //       setTableData(updatedPlans);
  //     } else {
  //       setTableData(checkAllPlans);
  //       resRef.current = [];
  //     }

  //     // setPlanData(result?.data);
  //     setLoader(false);
  //     setPageCount(result?.data.total);
  //   });
  // };

  // const onHandleFetch: any = (options: {
  //   limit?: number | string;
  //   searchtext?: string;
  //   pageNumber?: number;
  //   sort_column?: string;
  //   sort_direction?: string;
  // }) => {
  //   let newsortkey = "";
  //   if (sort.key === "rate_center_display") {
  //     newsortkey = "rate_center";
  //   } else {
  //     newsortkey = sort.key;
  //   }

  //   setLoader(true);

  //   view_Individual_Plan(
  //     {
  //       limit: options?.limit || perPage,
  //       // limit: pageCount,
  //       pageId: options?.pageNumber || pageNumber,
  //       sort_column:
  //         options?.sort_column === "rate_center_display"
  //           ? "rate_center"
  //           : options?.sort_column || newsortkey,
  //       sort_direction: options?.sort_direction || sort.order,
  //       searchtext:
  //         options?.searchtext === undefined
  //           ? searchtext
  //           : options?.searchtext === ""
  //           ? ""
  //           : options?.searchtext,
  //     },
  //     id
  //   ).then((result: any) => {
  //     const plans = result?.data?.items;
  //     console.log("plansb", plans);

  //     if (!result.success || plans?.length === 0) {
  //       setLoader(false);
  //       setResultNotFound(true);
  //       setTableData(plans);
  //       return;
  //     }

  //     setResultNotFound(false);

  //     setPlanData(result?.data);
  //     setIsDirty(true);

  //     const updatedPlans = plans.map((plan: any) => {
  //       const isUnselected = unselectedRef.current.some(
  //         (item: any) => item.uuid === plan.uuid
  //       );

  //       if (isUnselected) {
  //         return { ...plan, checked: false };
  //       }

  //       const isSelectedFromAPI = plan.is_selected;
  //       const isSelectedFromRef = resRef.current.some(
  //         (item: any) => item.uuid === plan.uuid
  //       );

  //       if (isSelectedFromAPI || isSelectedFromRef) {
  //         if (!resRef.current.some((item: any) => item.uuid === plan.uuid)) {
  //           resRef.current.push(plan);
  //         }
  //         return { ...plan, checked: true };
  //       }

  //       return { ...plan, checked: false };
  //     });

  //     const checkAllPlans = plans.map((plan: any) => ({
  //       ...plan,
  //       checked: true,
  //     }));

  //     if (!checkedAll) {
  //       setTableData(updatedPlans);
  //     } else {
  //       setTableData(checkAllPlans);
  //       resRef.current = []; // Optionally clear if "select all" is toggled
  //     }

  //     setLoader(false);
  //     setPageCount(result?.data.total);
  //   });
  // };
  const onHandleFetch: any = (options: {
    limit?: number | string;
    searchtext?: string;
    pageNumber?: number;
    sort_column?: string;
    sort_direction?: string;
  }) => {
    let newsortkey =
      sort.key === "rate_center_display" ? "rate_center" : sort.key;

    setLoader(true);

    view_Individual_Plan(
      {
        limit: options?.limit || perPage,
        pageId: options?.pageNumber || pageNumber,
        sort_column:
          options?.sort_column === "rate_center_display"
            ? "rate_center"
            : options?.sort_column || newsortkey,
        sort_direction: options?.sort_direction || sort.order,
        searchtext:
          options?.searchtext === undefined
            ? searchtext
            : options?.searchtext === ""
            ? ""
            : options?.searchtext,
      },
      id
    ).then((result: any) => {
      const plans = result?.data?.items;

      if (!result.success || plans?.length === 0) {
        setLoader(false);
        setResultNotFound(true);
        setTableData([]);
        return;
      }

      setResultNotFound(false);
      setPlanData(result?.data);
      setIsDirty(true);

      // ✅ Always check against resRef.current + unselectedRef
      const updatedPlans = plans.map((plan: any) => {
        const isUnselected = unselectedRef.current.some(
          (item: any) => item.uuid === plan.uuid
        );
        if (isUnselected) return { ...plan, checked: false };

        const isSelected =
          plan.is_selected ||
          resRef.current.some((item: any) => item.uuid === plan.uuid);

        if (isSelected) {
          if (!resRef.current.some((item: any) => item.uuid === plan.uuid)) {
            resRef.current.push(plan);
          }
          return { ...plan, checked: true };
        }
        return { ...plan, checked: false };
      });

      // ✅ check if all visible rows are selected
      const allVisibleSelected =
        updatedPlans.length > 0 &&
        updatedPlans.every((row: any) => row.checked);

      const ttileCopy = [...tableTitles];
      const selectAllCol: any = ttileCopy.find((node: any) => node.selectAll);
      if (selectAllCol) selectAllCol.checked = allVisibleSelected;

      setCheckedAll(allVisibleSelected);
      setTableTitles(ttileCopy);
      setTableData(updatedPlans);

      setLoader(false);
      setPageCount(result?.data.total);
    });
  };

  const onHandleSort = (node: any, orderBy: string) => {
    setSort({ key: node.key, order: orderBy });
    onHandleFetch({ sort_column: node.key, sort_direction: orderBy });
  };

  // const selectAllCheckbox = (action: any, data: any) => {
  //   const clone = [...tableData];
  //   const ttile = [...tableTitles];
  //   if (data?.selectAll === true) {
  //     // const result: any = ttile.find((node: any) => {
  //     //   return node.key === data.key;
  //     // });
  //     // result.checked = !result?.checked || false;
  //     // clone.map((node: any) => {
  //     //   node.checked = result?.checked;
  //     // });
  //     // setCheckedAll(result.checked);
  //   } else {
  //     setCheckedAll(false);

  //     const result = clone.find((node: any) => {
  //       return node.uuid === data.uuid;
  //     });

  //     result.checked = !result?.checked || false;
  //     const matched = tableData?.filter(
  //       (node: any) => node?.uuid === result.uuid
  //     );
  //     if (result?.checked) {
  //       resRef.current = [...(resRef.current || []), ...matched];
  //       unselectedRef.current = unselectedRef.current.filter(
  //         (item: any) => item.uuid !== result.uuid
  //       );
  //     } else {
  //       resRef.current = resRef.current.filter(
  //         (item: any) => item.uuid !== result.uuid
  //       );
  //       unselectedRef.current.push(result);
  //     }
  //   }
  //   const result = clone.find((node: any) => {
  //     return node?.checked ? node?.checked : false;
  //   });

  //   setTableTitles(ttile);
  //   setTableData(clone);
  // };
  const selectAllCheckbox = (action: any, data: any) => {
    const clone = [...tableData];
    const ttile = [...tableTitles];

    if (data?.selectAll === true) {
      // 🔹 Handle "Select All" for current visible rows
      const selectAllCol: any = ttile.find((node: any) => node.selectAll);
      selectAllCol.checked = !selectAllCol?.checked || false;

      clone.forEach((row: any) => {
        row.checked = selectAllCol.checked;
        if (selectAllCol.checked) {
          if (!resRef.current.some((r) => r.uuid === row.uuid)) {
            resRef.current.push(row);
          }
          unselectedRef.current = unselectedRef.current.filter(
            (item: any) => item.uuid !== row.uuid
          );
        } else {
          resRef.current = resRef.current.filter(
            (item: any) => item.uuid !== row.uuid
          );
          if (!unselectedRef.current.some((r) => r.uuid === row.uuid)) {
            unselectedRef.current.push(row);
          }
        }
      });

      setCheckedAll(selectAllCol.checked);
    } else {
      // 🔹 Handle single row toggle
      const row = clone.find((node: any) => node.uuid === data.uuid);
      if (row) {
        row.checked = !row.checked;
        if (row.checked) {
          if (!resRef.current.some((r) => r.uuid === row.uuid)) {
            resRef.current.push(row);
          }
          unselectedRef.current = unselectedRef.current.filter(
            (item: any) => item.uuid !== row.uuid
          );
        } else {
          resRef.current = resRef.current.filter(
            (item: any) => item.uuid !== row.uuid
          );
          if (!unselectedRef.current.some((r) => r.uuid === row.uuid)) {
            unselectedRef.current.push(row);
          }
        }
      }

      // 🔹 Update select-all based on visible rows
      const allSelected = clone.length > 0 && clone.every((row) => row.checked);
      const selectAllCol: any = ttile.find((node: any) => node.selectAll);
      if (selectAllCol) selectAllCol.checked = allSelected;
      setCheckedAll(allSelected);
    }

    setTableTitles(ttile);
    setTableData(clone);
  };

  const get_DCID_TableData = (pgNum: number) => {
    setPageNumber(pgNum);
    onHandleFetch({ pageNumber: pgNum });
  };

  // this function handles every button clicks for navigation :)
  const onhandleStateChange = (state: any, data: any) => {
    if (state === "Rate Center") {
      state = "ratecenter";
    }
    navigate(`${state}`, { replace: false });
  };

  const actionHandler = (action: string, data: any, index: number) => {
    const actionsMap: any = {
      "Rate Center": onhandleStateChange,
      selectall: selectAllCheckbox,
      change: selectAllCheckbox,
    };
    const act = actionsMap[action];
    if (act) {
      act(action, data);
    } else {
      console.log("actionHandler Error");
    }
  };

  const onHandleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setIsDirty(true);
    if (name === "dids_per_npa") {
      const parsed = parseInt(value, 10);
      if (isNaN(parsed) || parsed < 1) return;
      setFormData((prev: any) => ({ ...prev, [name]: parsed }));
    } else {
      setFormData((prev: any) => ({ ...prev, [name]: value }));
    }
  };

  const onHandleUpdate = () => {
    setLoader(true);
    const npaIds = resRef.current.map((node: any) => {
      return node?.uuid;
    });

    let payload: any = {
      npa_ids: npaIds,
      dids_per_npa: formData.dids_per_npa,
      name: formData.name,
    };
    const nameEmpty = !formData.name?.trim();
    const didsPerNpa = Number(formData.dids_per_npa);
    const didsInvalid = isNaN(didsPerNpa) || didsPerNpa < 1;
    const noNpaSelected = !npaIds.length;

    if (nameEmpty || isNaN(didsPerNpa)) {
      Notification("Failed", "Please fill all fields", "danger");
      setLoader(false);
    } else if (didsInvalid) {
      Notification("Failed", "Minimum DIDs per NPA must be 1", "danger");
      setLoader(false);
    } else if (noNpaSelected) {
      Notification("Failed", "No NPA's selected", "danger");
      setLoader(false);
    } else {
      update_Individual_Dcid_Plan(id, payload).then((result: any) => {
        setLoader(true);

        if (!result.success) {
          setLoader(false);
          Notification(
            "Failed",
            `${
              result?.message
                ? result?.message
                : "Oops! Something went wrong. Please try again later"
            }`,
            "danger"
          );
        } else {
          Notification("Success", "Plan updated successfully", "success");
          setLoader(false);
          // navigate(-1);
          navigate(`/app/dcid`, { replace: false });
        }
      });
    }
  };

  const handlePerPage = (value: any) => {
    console.log("heyyyyy");
    value = parseInt(value);
    setPerPage(value);
    setPageNumber(1);
    onHandleFetch({ limit: value, pageNumber: 1 });
  };

  const handleChange = (pgNum: number) => {
    get_DCID_TableData(pgNum);
    setPageNumber(pgNum);
  };

  const onHandleCancel = () => {
    navigate(`/app/dcid`, { replace: false });

    // const clone = [...tableData];
    // const title = [...tableTitles];
    // const result = clone.map((node: any) => {
    //   return (node.checked = false);
    // });
    // title[3].checked = false;
    // setTableData(clone);
    // setTableTitles(title);
  };
  // const handleSearch = (data: string) => {
  //   setPageNumber(1);
  //   setSearchText(data);
  //   onHandleFetch({ searchtext: data, pageNumber: 1, limit: perPage });
  // };
  const handleSearch = (data: string) => {
    setPageNumber(1);
    setSearchText(data);
    setCheckedAll(false); // ✅ reset select all when searching
    onHandleFetch({ searchtext: data, pageNumber: 1, limit: perPage });
  };

  useEffect(() => {
    console.log("planData.dids_per_npa1", planData.dids_per_npa);
    if (planData && !isDirty) {
      console.log("planData.dids_per_npa2", planData.dids_per_npa);

      setFormData({
        name: planData.name || "",
        dids_per_npa: planData.dids_per_npa || "",
      });
    }
  }, [planData]);
  const plan_Name = useSelector(
    (state: any) => state.BreadCrumbsList.dcid_PlanName
  );
  useEffect(() => {
    console.log("resssss", res);

    res[1] = {
      display: `${plan_Name}`,
      path: "dcid/" + id + "/edit",
    };
    res[2] = {
      display: "Edit",
      path: "dcid/" + id + "/edit",
    };
    dispatch(setBreadcrumbs(res));
  }, []);

  useEffect(() => {
    get_DCID_TableData(1);
  }, []);
  return (
    <div>
      <div className="h-full py-3 flex relative  rounded-md">
        <Backdrop className="!z-[99999999999]" open={loader}>
          <Lottiefy loop={true} json={loaderLottie} height={100} width={100} />
        </Backdrop>
        <div
          className={`h-[calc(100vh-125px)] w-full  overflow-x-auto overflow-y-hidden  rounded-md bg-[#fff]`}
        >
          <FadeIn>
            <div className="pt-3">
              <TableTopBar
                title={"Edit DCID Plan"}
                button={false}
                manageState={manageState}
                setManageState={setManageState}
                onhandleStateChange={onhandleStateChange}
                permission={"provision.users.post"}
                // buttonText={"Rate Center"}
                search={true}
                searchtext={searchtext}
                setSearchText={setSearchText}
                handleKeyPress={handleKeyPress}
                handleSearch={handleSearch}
                CSV={false}
                setHandleKeyPress={setHandleKeyPress}
                actionHandler={actionHandler}
              />
            </div>

            <div className="p-2 ">
              <div className="flex p-2 gap-x-[68px] ">
                <label className="text-[#7c7c7c] font-semibold text-[16px] items-center flex">
                  Plan Name
                </label>
                <input
                  type="text"
                  id="plan_name_textbox"
                  value={formData.name}
                  name="name"
                  className="border border-[#696969] rounded p-2 w-[340px] focus:outline-none "
                  onChange={onHandleChange}
                />
              </div>

              <div className="flex p-2 gap-x-[48px] ">
                <label className="text-[#7c7c7c] font-semibold text-[16px] items-center flex">
                  DIDs per NPA
                </label>
                <input
                  type="number"
                  id="dids_per_npa_textbox"
                  name="dids_per_npa"
                  min="1"
                  value={formData?.dids_per_npa || ""}
                  className="border border-[#696969] rounded p-2 w-[340px] focus:outline-none"
                  onChange={onHandleChange}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") e.preventDefault(); // block negative
                  }}
                  onInput={(e: any) => {
                    if (e.target.value < 1) e.target.value = ""; // clear invalid input
                  }}
                />
              </div>
              <div className="flex"></div>
            </div>
            <div className="h-[calc(100vh-500px)]">
              <Table
                tableTitles={tableTitles}
                tableData={tableData}
                setTableData={setTableData}
                actionHandler={actionHandler}
                setTableTitles={setTableTitles}
                button={true}
                buttonIndex={4}
                buttonText1={"manage"}
                width={"w-[calc(100vw-122px)] overflow-auto"}
                scrollHeight={"h-[calc(100vh-480px)] overflow-y-auto"}
                manageState={manageState}
                setManageState={setManageState}
                onHandleSort={onHandleSort}
                onhandleStateChange={onhandleStateChange}
                permission={"provision.users.put"}
                actions={true}
                resultNotFound={resultNotFound}
              />
            </div>

            <div className=" h-full py-4 px-3 flex  mt-2 float-right">
              <ThemedButton
                children={"Cancel"}
                icon="custom"
                theme="secondary"
                // valiData={callReport}
                // change={setCallReport}
                click={onHandleCancel}
              />
              <ThemedButton
                children={"Update"}
                icon="custom"
                theme="primary"
                click={() => {
                  onHandleUpdate();
                }}
                // valiData={tableData}
                // change={setTableData}
                // click={onHandleUpdate}
                // loading={buttonLoader}
              />
            </div>

            {!resultNotFound && tableData.length > 0 && (
              <PaginationButtons
                pageNumber={pageNumber}
                handleChange={handleChange}
                pageCount={pageCount}
                perPage={perPage}
                handlePerPage={handlePerPage}
                enableAll={true}
                hideLimit={true}
              />
            )}
          </FadeIn>
        </div>
      </div>
    </div>
  );
}

export default EditDcidPlan;
